import React, { useState } from "react";
import { Modal } from "antd";

const EditChapterModal = (props) => {
  const [chaptersState, setChaptersState] = useState(
    props.data?.chapters || [],
  );
  const [includeNoneState, setIncludeNoneState] = useState(
    props.data?.includeNone || false,
  );

  return (
    props.showModal && (
      <Modal
        title={<h5>Set Chapters</h5>}
        width={700}
        centered
        open={props.showModal}
        onOk={() => {
          props.onUpdateField({
            chapters: chaptersState,
            includeNone: includeNoneState,
          });
        }}
        onCancel={() => {
          props.onClose();
        }}
        footer={[]}
      >
        <div style={{ width: "100%" }}>
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            <div className="col-md-12">
              <span>
                Chapters are currently used only as a way for members to
                identify themselves. Chapter names will appear in member
                profiles and in the admin dashboard.
              </span>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-md-12">
              <span>
                Reach out to support@chant.fan to discuss options for
                supporting chapters.
              </span>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-md-12">
              <span>If selected, this field will be required.</span>
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-md-12">
              <div style={{ display: "flex", flexWrap: "nowrap" }}>
                <div className="d-flex ">
                  <div className="col">
                    <input
                      style={{ height: "20px", width: "20px" }}
                      type="checkbox"
                      className="form-control-input cursor-pointer"
                      id="includeNone"
                      checked={includeNoneState}
                      onChange={(e) => {
                        setIncludeNoneState(e.target.checked);
                      }}
                    />
                  </div>
                </div>

                <div
                  className="d-flex "
                  style={{ alignItems: "center" }}
                >
                  <label>
                    Include 'None' as option in form dropdown? Provides option
                    for members who are not part of a chapter.
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-1">
            <div className="col-md-12">
              <div className="col-md-6 d-flex ">
                <h5>Chapters</h5>
              </div>
              <div className="col-md-6 d-flex ">
                <div className="col">
                  {chaptersState &&
                    chaptersState.map((value, index) => {
                      return (
                        <div
                          key={index}
                          className="row mt-1"
                          style={{
                            alignItems: "center",
                            flexWrap: "nowrap",
                            paddingLeft: 15,
                          }}
                        >
                          <input
                            value={value}
                            onChange={(e) => {
                              let values = chaptersState;
                              values[index] = e.target.value;
                              setChaptersState([...values]);
                            }}
                            style={{
                              border: "1px solid #c4c4c4",
                              borderRadius: 0,
                              padding: "5px 8px",
                            }}
                          />
                          <div
                            className="ml-2"
                            onClick={() => {
                              let values = chaptersState;
                              values.splice(index, 1);
                              setChaptersState([...values]);
                            }}
                          >
                            x
                          </div>
                        </div>
                      );
                    })}
                  <div
                    className="span-link"
                    onClick={() => {
                      let values = chaptersState || [];
                      values.push("");
                      setChaptersState([...values]);
                    }}
                  >
                    +Add Chapter
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="row mt-4"
            style={{ justifyContent: "center" }}
          >
            <div className="col-md-2">
              <div
                className="row px-4 py-2"
                style={{
                  border: "1px solid #000000",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
                onClick={() => {
                  props.onUpdateField({
                    chapters: chaptersState,
                    includeNone: includeNoneState,
                  });
                }}
              >
                <span>Save</span>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    )
  );
};

export default EditChapterModal;
